/**
*****************************************
*										                    *
* NAGARRO  - CSX - CONFIDENTIAL         *
*										                    *
*****************************************
*/
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';

import { ConfigService } from '../../../core/services/config.service';
import { HistoryOps } from '../../../core/model/history-ops.model';
import { LmsModuleService } from '../../../core/services/lms-module.service';
import { Tab } from '../../../core/model/tab.model';
import { TrainData } from '../../../core/model/train-data.model';

@Component({
  selector: 'lms-train-history-header',
  templateUrl: './train-history-header.component.html',
  styleUrls: ['./train-history-header.component.scss']
})
export class TrainHistoryHeaderComponent implements OnInit, OnChanges, OnDestroy {

  @Input() selectedTab: Tab;
  @Input() subTypes: any;
  @Input() historyOps: HistoryOps;
  trainSVG: TrainData;
  tabLevel: number;

  @Output() historyTypeValueChange: EventEmitter<HistoryOps> = new EventEmitter<HistoryOps>();

  /**
   * Creates an instance of TrainHistoryHeaderComponent.
   * @param {LmsModuleService} lmsModuleService
   * @memberOf TrainHistoryHeaderComponent
   */
  constructor(private lmsModuleService: LmsModuleService, private configService: ConfigService) {
    this.tabLevel = this.configService.getConfigData().tabIndex.subTabs;
    this.historyOps = {};
    this.trainSVG = {};
  }

  /**
   * this is the life cycle method od this component
   * and called on initialization of this component
   * @memberOf TrainHistoryHeaderComponent
   */
  ngOnInit() {
  }

  /**
   * this is the life cycle method of this component
   * will be called when any changes occured in this
   * component
   * @memberOf TrainHistoryHeaderComponent
   */
  ngOnChanges() {
    if (this.selectedTab && this.selectedTab.tabSearchParameter) {
      if (!this.selectedTab.tabSearchParameter.spinnerVal) {
        this.selectedTab.tabSearchParameter.spinnerVal = 5;
        this.historyOps.days = this.selectedTab.tabSearchParameter.spinnerVal;
        this.lmsModuleService.updateSelectedTab(this.selectedTab);
      } else {
        this.historyOps.days = this.selectedTab.tabSearchParameter.spinnerVal;
      }
      if (!this.selectedTab.tabSearchParameter.displayType) {
        this.selectedTab.tabSearchParameter.displayType = ' ';
        this.historyOps.displayType = this.selectedTab.tabSearchParameter.displayType;
        this.lmsModuleService.updateSelectedTab(this.selectedTab);
      } else {
        this.historyOps.displayType = this.selectedTab.tabSearchParameter.displayType;
      }
      if (this.selectedTab.subTypeDetail.history.status === 'loaded' || this.selectedTab.subTypeDetail.history.status ===  'refresh') {
        this.trainSVG.trainIdentifier = this.selectedTab.tabSearchParameter.searchText;
      }
    }
  }

  /**
   * this mehtod is used to catch values changes emit by child
   * value changes are changes in days/display type value
   * @param {any} event
   * @memberOf TrainHistoryHeaderComponent
   */
  public historyTypeValueChangeListner(event) {
    this.historyTypeValueChange.emit(event);
  }

  /**
   * this is the life cycle method of this component
   * and will be called on destroy of this component
   * @memberOf TrainHistoryHeaderComponent
   */
  ngOnDestroy() {
    this.selectedTab = null;
    this.historyOps = null;
  }

}
